document.addEventListener('DOMContentLoaded', () => {

  const checkboxs = document.querySelectorAll('.lookbook-detail .coordinatedetail_item .js_itemcheck');
  const cta = document.querySelector('.lookbook-detail button.product-form__submit');

  colorSwatchesForLookBookDetail();
  sizeVariantChange();
  changeCheckbox();
  addToCart();

  function sizeVariantChange() {
    const sizeVariants = document.querySelectorAll('.lookbook-detail .coordinatedetail_item .item_size_inner label.radio--size');
    sizeVariants.forEach(variant => {
      variant.addEventListener('click', () => {
        const variantId = variant.querySelector('input').getAttribute('data-variant-id');
        const outOfStock = variant.querySelector('input').getAttribute('data-disabled');
        variant.closest('.coordinatedetail_item').querySelector('.coordinatedetail_item_checkbox .js_itemcheck').setAttribute('value', variantId);
        if (outOfStock) {
          variant.closest('.coordinatedetail_item').querySelector('.coordinatedetail_item_checkbox').classList.add('hidden');
          variant.closest('.coordinatedetail_item').querySelector('.no_stock').classList.remove('hidden');
        } else {
          variant.closest('.coordinatedetail_item').querySelector('.coordinatedetail_item_checkbox').classList.remove('hidden');
          variant.closest('.coordinatedetail_item').querySelector('.no_stock').classList.add('hidden');
        }
      })
    })
  }

  function colorSwatchesForLookBookDetail() {
    const colorGroup = document.querySelectorAll('.lookbook-detail .coordinatedetail_item .item_color_inner label.radio--color');
    colorGroup.forEach(group => {
      group.addEventListener('click', () => {
        const productHandle = group.getAttribute("data-handle");
        group.closest('.lookbook-product-group-container').querySelectorAll('.coordinatedetail_item').forEach(item => {
          item.classList.remove('selected');
          if (item.getAttribute('data-product') == productHandle) {
            item.classList.add('selected');
          }
        })
      })
    })
  }

  function changeCheckbox() {
    checkboxs.forEach(checkbox => {
      checkbox.addEventListener('change', () => {
        if (checkbox.closest('.lookbook-product-group-container')) {
          checkbox.closest('.lookbook-product-group-container').querySelectorAll('.coordinatedetail_item .js_itemcheck').forEach(box => {
            if (box != checkbox) box.checked = checkbox.checked;
          })
        }
        updateCTA();
      })
    })
  }

  function updateCTA() {
    let showCTA = false;
    checkboxs.forEach(checkbox => {
      if (checkbox.checked) showCTA = true;
    });
    if (showCTA) {
      cta.classList.remove('hidden')
    } else {
      cta.classList.add('hidden')
    }
  }

  function addToCart() {
    cta.addEventListener('click', (event) => {
      event.preventDefault();
      let items = [];
      checkboxs.forEach(checkbox => {
        if (checkbox.checked) {
          if (checkbox.closest('.coordinatedetail_item').classList.contains('selected')) items.push({ id: checkbox.getAttribute('value'), quantity: 1 });
        }
      })
      let formData = {
        'items': items
      }
      console.log(formData, "formData");
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => {
          console.log(response, "response");
          window.location = window.routes.cart_url;
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    });
  }
})